<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_62_2076)">
<rect width="28" height="28" rx="14" fill="#733801" fill-opacity="0.2"/>
<path d="M3.5 23.0168C3.5 19.924 6.00721 17.4168 9.1 17.4168H18.9C21.9928 17.4168 24.5 19.924 24.5 23.0168V32.8168C24.5 35.9096 21.9928 38.4168 18.9 38.4168H9.1C6.00721 38.4168 3.5 35.9096 3.5 32.8168V23.0168Z" fill="#733801" fill-opacity="0.5"/>
<circle cx="14.0001" cy="9.80001" r="5.6" fill="#733801" fill-opacity="0.5"/>
</g>
<defs>
<clipPath id="clip0_62_2076">
<rect width="28" height="28" rx="14" fill="white"/>
</clipPath>
</defs>
</svg>
